<template>
  <div class="Shortcuts">
    <div v-for="(item, index) in links" :key="index" class="shortcut-item" :style="{'background-image':'url('+item.icon+')'}" @click="go(item.url)">
    </div>
    <el-input placeholder="Tesla Login Email" clearable v-model="email" autocomplete="off"></el-input>
    <el-input placeholder="Please input Password" v-model="password" autocomplete="off" clearable show-password></el-input>
    <!-- <el-button type="primary" @click="Login">Login</el-button> -->
  </div>
</template>

<script>
import daum from "@/assets/images/daum.png";

const tjs = require('teslajs');
export default {
  name: "Shortcuts",
  data() {
    return {
      address: "",
      links:[
        { name:"다음", icon:daum, url:"https://www.daum.net/"}
      ],
      email:"kang3d@daum.net",
      password:"ehddnjs09171212!"
    };
  },
  mounted() {},
  methods: {
    go(url) {
      location.href = "https://www.youtube.com/redirect?q=" + url;
    },
    Login(){
      console.log(this.email, this.password);
      // 로그인
      let baseURL = "https://owner-api.teslamotors.com";
      let client_id = "81527cff06843c8634fdc09e8ac0abefb46ac849f38fe1e431c2ef2106796384";
      let client_secret = "c7257eb71a564034f9419ee651c7d0e5f7aa6bfbd18bafb5c5c033b093bb2fa3";

      console.log(baseURL + "/oauth/token");

      fetch( baseURL + "/oauth/token", {
        method: "POST",
        mode: 'no-cors',
        headers: { 
          "Content-Type": "application/json",
          cache: "no-cache",
          'Cache-Control': 'no-cache',
          "Access-Control-Allow-Origin": "*",
        },
        body: JSON.stringify({
          grant_type    : "password",
          client_id     : "81527cff06843c8634fdc09e8ac0abefb46ac849f38fe1e431c2ef2106796384",
          client_secret : "c7257eb71a564034f9419ee651c7d0e5f7aa6bfbd18bafb5c5c033b093bb2fa3",
          email         : this.email,
          password      : this.password,
        })
      })
      .then((response) => {
        console.log(response);
        if(response.ok){
          return response.json();
        }
        throw new Error('Network response was not ok');
      })
      .then((json) => {
        console.log(json);
      })
      .catch((error) => {
          console.log(error);
      })


      // this.$tesla.LOGIN({ 
      //   email : this.email,
      //   password : this.password
      // }).then( ( response )=>{
      //   console.log(response);
      //   // this.$tesla.SET_TOKEN( { token_type:response.token_type, access_token: response.access_token  }).then((v)=>{
      //   //   console.log(v);
      //   // });
      // }).catch( ( error )=>{
      //   console.log("LoginPage : 로그인 실패");
      //   console.log( error );
      // })
    }
  }
};
</script>

<style scoped>
.Shortcuts {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  width:90%;
}
.shortcut-item{
  position:relative;
  display: inline-block;
  width:240px; 
  height:150px; 
  min-width:240px;
  min-height:150px;
  box-sizing: border-box;
  margin:20px 40px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  text-align:center;
  background-color:rgba(0,0,0,0.05);
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.15s;
}
.shortcut-item:active{
  background-color:rgba(0,0,0,0.1);
  background-size: 65%;
  transition: all 0.15s;
}




div.des {
  color: #666666;
  transform: rotate(-0.03deg);
  margin-top: 30px;
  letter-spacing: -0.5px;
}

div.Economy input {
  height: 50px;
  width: 800px;
  border: 1px solid #333333;
  margin-bottom: 40px;
  font-size: 20px;
  text-align: center;
  letter-spacing: -0.5px;
  transform: rotate(-0.028deg);
  border-radius: 5px;
  background-color: #ff3333;
  color: #ffffff;
  outline: none;
  font-weight: 200;
}

div.Economy input::placeholder {
  color: rgba(255, 255, 255, 0.6);
  font-weight: 200;
}
</style>



// WEBPACK FOOTER //
// src/pages/Tesla/index.vue